<template>
    <div v-if="attendances.length">
        <div :class="{'message-content fr-view': isProject}">
            <ul class="vertical-align-middle">
                <template v-for="entry in attendances">
                    <li>
                        <template v-if="isProject || isContact">
                            <i v-if="showSystem" v-tooltip="systemIcon[entry.beginSystem][systemTooltipKey]" class="material-icons md-16 link-color cursor-help" aria-hidden="true" role="img">{{systemIcon[entry.beginSystem].icon}}</i>
                            <span>
                                {{dateHelper('H:i', entry.begin)}} bis {{entry.end ? dateHelper('H:i', entry.end) : '-- : --'}}
                            </span>
                            <i v-if="showSystem && entry.end" v-tooltip="systemIcon[entry.endSystem][systemTooltipKey]" class="material-icons md-16 link-color cursor-help" aria-hidden="true" role="img">{{systemIcon[entry.endSystem].icon}}</i>
                        </template>

                        <template v-if="isProject">
                            <strong>{{entry.project}}</strong>
                            <strong v-if="isContact">({{entry.contact}})</strong>
                        </template>

                        <template v-if="!isProject && isContact">
                            <strong> {{entry.contact}}</strong>
                        </template>

                        <template v-if="!isProject && !isContact">
                            <span v-if="entry.beginError || entry.endError || entry.error">
                                <i v-tooltip="entry.beginError || entry.endError || entry.error" class="material-icons evaluation-error" aria-hidden="true" role="img">clear</i>
                            </span>

                            <i v-if="allowWorkOutsideWorkTime && entry.isOutOfWorkTime" v-tooltip="'Diese Zeiten werden nicht Ihrer wöchentlichen Arbeitszeit angerechnet, da sie außerhalb Ihrer hinterlegten Arbeitszeiträume liegen.'" class="material-icons text-warning font-size-20" aria-hidden="true" role="img">priority_high</i>

                            <i v-if="showSystem" v-tooltip="systemIcon[entry.beginSystem][systemTooltipKey]" class="material-icons md-16 link-color cursor-help" aria-hidden="true" role="img">{{systemIcon[entry.beginSystem].icon}}</i>

                            <span v-tooltip="getBeginTooltip(entry)" :class="{'evaluation-error': entry.beginError, 'text-warning': allowWorkOutsideWorkTime && entry.isOutOfWorkTime}">{{dateHelper('H:i', entry.begin)}}</span>

                            <span v-if="null !== entry.beginLocation" v-tooltip="buildLocationTooltip(entry.beginLocation, entry.beginLocationAddress, entry.beginLocationUnavailable, entry.beginLocationAccuracy)">
                                <i v-if="[LOCATION_AVAILABILITY_UNAVAILABLE, LOCATION_AVAILABILITY_NOT_FOUND].includes(entry.beginLocationUnavailable)" class="material-icons text-danger cursor-help" role="img">fmd_bad</i>
                                <i v-else class="material-icons cursor-help" :class="{'text-success': !!entry.beginLocationAddress}" role="img">{{entry.beginLocationAddress ? 'where_to_vote' : 'place'}}</i>
                            </span>

                            <span>bis</span>

                            <template v-if="entry.end">
                                <span v-tooltip="getEndTooltip(entry)" :class="{'evaluation-error': entry.endError, 'text-warning': allowWorkOutsideWorkTime && entry.isOutOfWorkTime}">{{dateHelper('H:i', entry.end)}}</span>

                                <span v-if="null !== entry.endLocation" v-tooltip="buildLocationTooltip(entry.endLocation, entry.endLocationAddress, entry.endLocationUnavailable, entry.endLocationAccuracy)">
                                    <i v-if="[LOCATION_AVAILABILITY_UNAVAILABLE, LOCATION_AVAILABILITY_NOT_FOUND].includes(entry.endLocationUnavailable)" class="material-icons text-danger cursor-help" role="img">fmd_bad</i>
                                    <i v-else class="material-icons cursor-help" :class="{'text-success': !!entry.endLocationAddress}" role="img">{{entry.endLocationAddress ? 'where_to_vote' : 'place'}}</i>
                                </span>

                                <i v-if="showSystem" v-tooltip="systemIcon[entry.endSystem].tooltip" class="material-icons md-16 link-color cursor-help" aria-hidden="true" role="img">{{systemIcon[entry.endSystem].icon}}</i>
                            </template>
                            <span v-else>
                                -- : --
                                <i v-if="isManualMode" v-tooltip="'Kein Ende hinterlegt'" class="material-icons md-16 link-color cursor-help  evaluation-error"
                                    aria-hidden="true"
                                    role="img">close</i>
                            </span>

                            <span v-if="entry.isOutOfWorkTime" v-tooltip="getEndTooltip(entry)" class="text-warning font">(außerhalb der Arbeitszeiten)</span>
                        </template>

                        <i v-if="requestedCorrections[entry.beginId] || requestedCorrections[entry.endId]" v-tooltip="getChangeTooltip(entry)" class="material-icons font-size-20" aria-hidden="true" role="img">hourglass_empty</i>
                        <i v-else-if="entry.correction" v-tooltip="getChangeTooltip(entry)" class="material-icons text-success font-size-20" aria-hidden="true" role="img">task_alt</i>
                        <i v-else-if="!isProject && entry.forgotLogout" v-tooltip="getChangeTooltip(entry)" class="material-icons text-success font-size-20" aria-hidden="true" role="img">info</i>

                        <template v-if="entry.homeoffice">&nbsp;<i v-tooltip="'Mobile Arbeit'" class="material-icons text-success font-size-20" aria-hidden="true" role="img">home</i></template>
                        <template v-if="entry.patrol">&nbsp;<i v-tooltip="'Dienstgang'" class="material-icons text-success font-size-20" aria-hidden="true" role="img">work</i></template>
                    </li>
                </template>
            </ul>
        </div>
    </div>
    <div v-else class="flex">
        <i v-if="isProject" class="material-icons" aria-hidden="true" role="img">remove</i>
        <div v-if="isBreak && requestedCorrections['break_' + date]">
            <i v-tooltip="getAddBreakTooltip(requestedCorrections['break_' + date])" class="material-icons font-size-20" aria-hidden="true" role="img">hourglass_empty</i>
        </div>
    </div>
</template>

<script lang="ts">
    import {getDayName, isAllDay} from '@/library/date';
    import {
        getWorkDayHoursBySettings,
        LOCATION_AVAILABILITY_ADDRESS_NOT_FOUND,
        LOCATION_AVAILABILITY_NOT_FOUND,
        LOCATION_AVAILABILITY_UNAVAILABLE,
        TIMETRACKER_SYSTEM_ICONS,
    } from '@/library/modules/time-tracker/time-tracker';
    import dateHelper from '@/utils/portuna/dateHelper';
    import {Component, Prop, Vue} from 'vue-facing-decorator';

    @Component({
        name: 'EvaluationAttendances',
        components: {},
        methods: {
            dateHelper,
        },
    })
    export default class EvaluationAttendances extends Vue
    {
        readonly $refs: { noteForm: HTMLFormElement };

        @Prop({
            type: Array,
            required: true,
        }) attendances: EvaluationAttendance[];

        @Prop({
            type: Object,
            required: true,
        }) requestedCorrections: Record<number, EvaluationRequestedCorrection>;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) isBreak: boolean;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) isProject: boolean;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) isContact: boolean;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) isManualMode: boolean;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) hasMultipleSystems: boolean;

        @Prop({
            type: String,
            default: '',
            required: false,
        }) date: boolean;

        @Prop({
            type: Object,
            default: () => {},
            required: true,
        }) settings: ITimeTrackerSettingsDateData;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) allowWorkOutsideWorkTime: boolean;

        LOCATION_AVAILABILITY_UNAVAILABLE = LOCATION_AVAILABILITY_UNAVAILABLE;

        LOCATION_AVAILABILITY_NOT_FOUND = LOCATION_AVAILABILITY_NOT_FOUND;

        systemIcon = TIMETRACKER_SYSTEM_ICONS;

        get systemTooltipKey()
        {
            return this.isBreak ? 'tooltipBreak' : 'tooltip';
        }

        get showSystem()
        {
            return this.hasMultipleSystems;
        }

        get workDays()
        {
            return getWorkDayHoursBySettings(this.settings || {});
        }

        getBeginTooltip(entry: ITimeTrackerTrackedTime)
        {
            let tooltip = 'Beginn: ' + dateHelper('H:i:s', entry.begin);

            if (entry.beginError)
            {
                tooltip += ` - ${entry.beginError}`;
            }

            tooltip += this.isBreak ? this.getBreakSettingsTooltip() : this.getWorkSettingsTooltip(entry);

            return tooltip;
        }

        getEndTooltip(entry: ITimeTrackerTrackedTime)
        {
            let tooltip = 'Ende: ' + dateHelper('H:i:s', entry.end);

            if (entry.endError)
            {
                tooltip += ` - ${entry.endError}`;
            }

            tooltip += this.isBreak ? this.getBreakSettingsTooltip() : this.getWorkSettingsTooltip(entry);

            return tooltip;
        }

        getWorkSettingsTooltip(entry: ITimeTrackerTrackedTime)
        {
            let tooltip = '';

            const workTimes = this.getWorkTimes(<string>dateHelper('Y-m-d', entry.begin));

            if (workTimes)
            {
                tooltip += `<br><br>Arbeitszeiten:<br>${workTimes.start} - ${workTimes.end}`;

                if (workTimes.hours)
                {
                    tooltip += ` (${workTimes.hours} Stunden)`
                }
            }
            else
            {
                tooltip += `<br>Kein Arbeitstag laut Einstellungen hinterlegt`;
            }

            return tooltip;
        }

        getBreakSettingsTooltip()
        {
            let tooltip = '<br><br>Pausenzeiten:';

            const breakCount = Number(Object.keys(this.settings).filter(key => key.includes('breaktime_max')).map(key => key.split('_')[2]).pop()) + 1;
            for (let i = 0; i < breakCount; i++)
            {
                const _isAllDay = isAllDay(this.settings['breaktime_start_' + i], this.settings['breaktime_end_' + i]);

                tooltip += `<br>${_isAllDay ? '00:00' : this.settings['breaktime_start_' + i]} - ${_isAllDay ? '24:00' : this.settings['breaktime_end_' + i]} (Maximal ${this.settings['breaktime_max_' + i]} Minuten)`;
            }

            return tooltip;
        }

        getChangeTooltip(entry: ITimeTrackerTrackedTime & {sourceBeginId: number, sourceEndId: number})
        {
            let tooltip = '';

            if (this.requestedCorrections.hasOwnProperty(entry.beginId) || this.requestedCorrections.hasOwnProperty(entry.endId))
            {
                let begin          = '';
                let requestedBegin = '';
                let end            = '';
                let requestedEnd   = '';

                if (this.requestedCorrections.hasOwnProperty(entry.beginId))
                {
                    begin          = dateHelper('H:i:s', entry.begin) as string;
                    requestedBegin = dateHelper('H:i:s', this.requestedCorrections[entry.beginId].new_stamp) as string;
                }

                if (this.requestedCorrections.hasOwnProperty(entry.endId))
                {
                    end          = dateHelper('H:i:s', entry.end) as string;
                    requestedEnd = dateHelper('H:i:s', this.requestedCorrections[entry.endId].new_stamp) as string;
                }

                let lineBreak   = requestedBegin && requestedEnd ? '<br>' : '';
                let beginString = requestedBegin ? `(Beginn) Original: ${begin} - Beantragt: ${requestedBegin}` : '';
                let endString   = requestedEnd ? `(Ende) Original: ${end} - Beantragt: ${requestedEnd}` : '';

                tooltip = `Für diesen Eintrag wurde eine Korrektur beantragt:<br>${beginString}${lineBreak}${endString}`;
            }
            else if (entry.correction || entry.begin !== entry.sourceBegin || entry.end !== entry.sourceEnd)
            {
                if (entry.beginId === entry.sourceBeginId && entry.endId === entry.sourceEndId)
                {
                    tooltip = `Dieser Eintrag wurde nachgetragen.`;
                }
                else
                {
                    tooltip = `Dieser Eintrag wurde korrigiert:<br>Original: ${dateHelper('H:i:s', entry.sourceBegin)} - ${dateHelper('H:i:s', entry.sourceEnd)}`;
                }
            }
            else if (entry.forgotLogoutDuration)
            {
                tooltip = 'Dieser Eintrag wurde durch einen vergessenen Logout nach 7 Stunden erstellt!';
            }
            else if (entry.forgotLogout)
            {
                tooltip = 'Dieser Eintrag wurde durch einen vergessenen Logout zur festen Uhrzeit erstellt!';
            }

            return tooltip;
        }

        getAddBreakTooltip(correction)
        {
            let tooltip = 'Für diesen Tag wurde eine Korrektur beantragt.<br>';

            if (this.isBreak)
            {
                tooltip += `Fehlende Pause: ${dateHelper('H:i:s', correction.new_break_begin_stamp)} - ${dateHelper('H:i:s', correction.new_break_end_stamp)}`;
            }

            return tooltip;
        }

        buildLocationTooltip(location: Nullable<[number, number]>, address: Nullable<string>, locationUnavailable: Nullable<0|1|2|3>, locationAccuracy: Nullable<number>)
        {
            if (locationUnavailable === LOCATION_AVAILABILITY_UNAVAILABLE)
            {
                return 'Der Standort konnte nicht ermittelt werden, da die erforderliche Berechtigung zur Standorterfassung nicht erteilt wurde oder die Standorterfassung nicht verfügbar war.';
            }

            if (locationUnavailable === LOCATION_AVAILABILITY_NOT_FOUND)
            {
                return 'Der Standort konnte vom Gerät nicht ermittelt werden.';
            }

            if (!location)
            {
                return '';
            }

            const latitudeSign  = location[0] < 0 ? 'S' : 'N';
            const longitudeSign = location[1] < 0 ? 'W' : 'E';

            let text = '';

            if (locationUnavailable === LOCATION_AVAILABILITY_ADDRESS_NOT_FOUND)
            {
                text += `Adresse: Es konnte keine Adresse zu den Koordinaten bestimmt werden.`;
            }
            else if (address)
            {
                text += `Adresse: ${address}`;
            }
            else
            {
                text += `Adresse: Die Adresse wird noch anhand der Koordinaten bezogen.`;
            }

            text += `<br>Koordinaten: ${location[0].toFixed(5)}° ${latitudeSign}, ${location[1].toFixed(5)}° ${longitudeSign}`;

            if (locationAccuracy)
            {
                text += `<br>Genauigkeit: ${locationAccuracy} Meter`;
            }

            return text;
        }

        getWorkTimes(date: Nullable<string>)
        {
            let dayName = date ? getDayName(date) : null;

            return dayName ? this.workDays[dayName] : null;
        }
    }
</script>